// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uGB3","buttons":"styles_buttons__a5QYA"};